<template>
  <div class="relative" style="">
    <!-- XL Circles -->
    <div
      class="hidden lg:inline-flex items-center justify-center absolute text-lg text-blue-500"
    >
      <a v-if="!embed" href="https://www.aberlour.org.uk"
        ><i class="fas fa-angle-left mr-2"></i
        ><span class="underline">Back to main site</span></a
      >
    </div>
    <div
      class="hidden xl:inline-flex rounded-full h-48 w-48 bg-aberlour-blue absolute text-white text-base ball bubble mt-8"
    >
      <div class="pl-4 pr-3 mt-4 pt-4 ml-3 text-lg">{{ leftCircleText }}</div>
    </div>
    <div
      class="hidden xl:inline-flex rounded-full h-24 w-24 items-center justify-center bg-aberlour-yellow opacity-75 absolute top-17 left-15 text-white mt-16"
    ></div>
    <div
      style="bottom: 0rem"
      class="hidden xl:inline-flex rounded-full h-48 w-48 items-center justify-center bg-aberlour-green absolute right-0 text-white pl-4 pr-3"
      :class="donationType == 'Single Donation' ? 'text-lg' : 'text-sm'"
    >
      {{ rightCircleText }}
    </div>
    <div
      style="bottom: 9rem"
      class="hidden xl:inline-flex rounded-full h-24 w-24 items-center justify-center bg-aberlour-blue opacity-75 absolute right-18 text-white"
    ></div>

    <!-- LG CIRCLES -->
    <div
      class="hidden lg:inline-flex xl:hidden rounded-full h-48 w-48 items-center justify-center bg-aberlour-blue absolute left-100 text-white text-lg pl-4 pr-2 py-2 mt-10"
    >
      {{ leftCircleText }}
    </div>
    <div
      class="hidden lg:inline-flex xl:hidden rounded-full h-24 w-24 items-center justify-center bg-aberlour-yellow opacity-75 absolute top-17 left-16 text-white mt-16"
    ></div>
    <div
      style="bottom: 0rem"
      class="hidden lg:inline-flex xl:hidden rounded-full h-48 w-48 items-center justify-center bg-aberlour-green absolute right-0 text-white  pl-4"
      :class="donationType == 'Single Donation' ? 'text-lg' : 'text-xs'"
    >
      {{ rightCircleText }}
    </div>
    <div
      style="bottom: 9rem"
      class="hidden lg:inline-flex xl:hidden rounded-full h-24 w-24 items-center justify-center bg-aberlour-blue opacity-75 absolute bottom-0 right-5 text-white"
    ></div>

    <!-- MD Circles -->
    <div
      class="hidden md:inline-flex lg:hidden rounded-full h-32 w-32 items-center justify-center bg-aberlour-blue absolute left-100 text-white text-xs pl-3"
    >
      {{ leftCircleText }}
    </div>
    <div
      class="hidden md:inline-flex lg:hidden rounded-full h-16 w-16 items-center justify-center bg-aberlour-yellow opacity-75 absolute top-14 left-12 text-white"
    ></div>
    <div
      style="bottom: 0rem"
      class="hidden md:inline-flex lg:hidden rounded-full h-32 w-32 items-center justify-center bg-aberlour-green absolute right-105 text-white text-xs pl-3"
    >
      {{ rightCircleText }}
    </div>
    <div
      style="bottom: 6rem"
      class="hidden md:inline-flex lg:hidden rounded-full h-16 w-16 flex items-center justify-center bg-aberlour-blue opacity-75 absolute right-8 text-white"
    ></div>

    <div class="mt-1 sm:mx-auto sm:w-full sm:max-w-lg">
      <div
        class="bg-white shadow sm-rounded-lg"
        :class="currentlyActiveStage.number == 1 ? 'py-4 px-4' : ''"
      >
        <div
          v-if="currentlyActiveStage.number == 1"
          class="font-extrabold max-w-sm mb-2 mx-auto hidden text-base sm:inline-block"
        >
          <span v-if="this.campaign == 6">Make a difference to the lives of children in Scotland now</span>
          <span v-else>Make a difference to the lives of disadvantaged children and families</span>
        </div>

        <div
          v-if="currentlyActiveStage.number != 1"
          class="py-2 px-6 bg-aberlour-purple text-white text-center text-xs"
        >
          <div class="">{{ donationType }} of £{{ donationAmount }}</div>
        </div>
        <div
          v-if="errorMessage"
          class="font-semibold text-white py-2 bg-red-400 text-center mb-4 border-red-900 border-2 rounded mx-4 mt-3"
        >
          <i class="fal fa-exclamation-triangle mr-3"></i> {{ errorMessage }}
        </div>
        <div
          :class="currentlyActiveStage.number > 1 ? 'py-4 px-4 sm:px-10' : ''"
        >
          <donation-stage-indicator class="" v-if="!express" />

          <!-- Stage 1 -->
          <transition name="fade" mode="in-out">
            <div
              class="mb-4"
              v-if="currentlyActiveStage.number == 1 && !express"
            >
              <div class="mt-1 sm:mx-auto sm:w-full">
                <div class="grid grid-cols-2 gap-3 pb-3">
                  <donation-type-selector
                    :selectedTitle="donationType"
                    title="Single Donation"
                  ></donation-type-selector>
                  <donation-type-selector
                    :selectedTitle="donationType"
                    title="Monthly Donation"
                  ></donation-type-selector>
                </div>
              </div>

              <transition class="fade" mode="out-in">
                <div>
                <div
                  class="text-aberlour-purple p-2 w-full font-semibold rounded-md text-center"
                  v-if="hideSuggestions == 'opacity-0'"
                >
                  <i class="fad fa-spinner-third fa-spin fa-2x"></i>
                </div>

                <div
                  class="grid grid-cols-4 gap-2 sm:gap-6"
                  :class="hideSuggestions"
                >
                  <donation-suggestion
                    v-for="suggestion in donationSuggestions"
                    :key="suggestion.amount"
                    :suggestedAmount="suggestion.amount"
                    :image="suggestion.image"
                    :text="suggestion.text"
                    :donationType="donationType"
                    :position="suggestion.position"
                    :selected="donationAmount == suggestion.amount"
                  />
                </div>
                </div>
              </transition>
              <div class="col-span-4">
                <donation-suggestion-banner
                  :key="suggestionAmount"
                  :image="suggestionImage"
                  :amount="suggestionAmount"
                  :donationType="donationType"
                  :text="suggestionText"
                  :position="suggestionPosition"
                  class="hidden"
                >
                </donation-suggestion-banner>
              </div>

              <div
                v-if="suggestionAmount == 'Other'"
                class="sm:mx-auto sm:w-full"
              >
                <div class="sm:grid sm:grid-cols-3 sm:gap-1 sm:items-start">
                  <label
                    for="amount"
                    class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >
                    Donation Amount
                  </label>
                  <div class="sm:mt-0 sm:col-span-3">
                    <div class="max-w-lg flex rounded-md shadow-sm">
                      <span
                        class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
                      >
                        £
                      </span>
                      <input v-model="gender" name="gender" type="text" class="gender-field">

                      <input
                        v-model="donationAmount"
                        type="number"
                        name="donation_amount"
                        id="amount"
                        autocomplete="off"
                        class="flex-1 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300 focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <!-- Stage 2 -->

          <transition name="fade" mode="out-in">
            <div v-if="currentlyActiveStage.number == 2">
              <div class="sm:mx-auto sm:w-full">
                <label
                  for="title"
                  class="block text-sm font-bold text-gray-700"
                >
                  Title
                </label>
                <div class="max-w-xs flex rounded-md">
                  <v-select
                    v-model="$v.title.$model"
                    name="title"
                    placeholder="Select"
                    type="text"
                    autocomplete="off"
                    required
                    class="p-0 max-w-sm shadow-sm focus:ring-aberlour-focus-blue w-6/12"
                    :options="['Mr.', 'Mrs.', 'Miss', 'Ms', 'Mx', 'Dr.', 'Rev']"
                    label=""
                    :class="vSelectfieldStatus($v.title)"
                  >
                  </v-select>
                </div>
                <div
                  class="text-xs mt-1 text-red-500 font-extralight"
                  v-if="!$v.title.required && $v.title.$error"
                >
                  You must enter your title
                </div>
              </div>

              <div class="sm:mx-auto sm:w-full mt-3">
                <label
                  for="first_name"
                  class="block text-sm font-bold text-gray-700"
                >
                  Your first name
                </label>
                <div class="max-w-lg flex rounded-md shadow-sm">
                  <input
                    v-model="$v.firstName.$model"
                    name="first_name"
                    type="text"
                    autocomplete="off"
                    required
                    class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    :class="fieldStatus($v.firstName)"
                  />
                </div>
                <div
                  class="text-xs mt-1 text-red-500 font-extralight"
                  v-if="!$v.firstName.required && $v.firstName.$error"
                >
                  You must enter your first name
                </div>
              </div>

              <div class="mt-3 sm:mx-auto sm:w-full">
                <label
                  for="last_name"
                  class="block text-sm font-bold text-gray-700"
                >
                  Your last name
                </label>
                <div class="max-w-lg flex rounded-md shadow-sm">
                  <input
                    v-model="lastName"
                    name="last_name"
                    type="text"
                    autocomplete="off"
                    required
                    class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    :class="fieldStatus($v.lastName)"
                  />
                </div>
                <div
                  class="text-xs mt-1 text-red-500 font-extralight"
                  v-if="!$v.lastName.required && $v.lastName.$error"
                >
                  You must enter your last name
                </div>
              </div>

              <div class="mt-3 sm:mx-auto sm:w-full mb-3">
                <label
                  for="email"
                  class="block text-sm font-bold text-gray-700"
                >
                  Your email address
                </label>
                <div class="max-w-lg flex rounded-md shadow-sm">
                  <input
                    v-model="email"
                    name="email"
                    type="email"
                    autocomplete="off"
                    required
                    class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    :class="fieldStatus($v.email)"
                  />
                </div>
                <div
                  class="text-xs mt-1 text-red-500 font-extralight"
                  v-if="!$v.email.required && $v.email.$error"
                >
                  You must enter your email
                </div>
                <div
                  class="text-xs mt-1 text-red-500 font-extralight"
                  v-if="!$v.email.email && $v.email.$error"
                >
                  You must enter a valid email
                </div>

                <div class="text-xs text-gray-600 pt-2">
                  We need your email address because we'll send confirmation of
                  your donation to this email address.
                </div>
              </div>

              <div class="mt-3 sm:mx-auto sm:w-full mb-3">
                <label
                  for="phone"
                  class="block text-sm font-bold text-gray-700"
                >
                  Your phone number
                </label>
                <div class="max-w-lg flex rounded-md shadow-sm">
                  <input
                    v-model="phone"
                    name="phone"
                    type="tel"
                    autocomplete="off"
                    required
                    class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    :class="fieldStatus($v.phone)"
                  />
                </div>
                <div
                  class="text-xs mt-1 text-red-500 font-extralight"
                  v-if="!$v.phone.minLength && $v.phone.$error"
                >
                  You must enter a valid phone number
                </div>
                <div
                  class="text-xs mt-1 text-red-500 font-extralight"
                  v-if="!$v.phone.maxLength && $v.phone.$error"
                >
                  You must enter a valid phone number
                </div>

                <div class="text-xs text-gray-400 pt-2">Optional</div>
              </div>
            </div>
          </transition>

          <transition name="fade" mode="out-in">
            <!--Stage 3 -->
            <div v-if="currentlyActiveStage.number == 3">
              <div class="sm:mx-auto sm:w-full">
                <label
                  for="address_search"
                  class="block text-sm font-bold text-gray-700"
                >
                  Search for your address
                </label>
                <div class="">
                  <v-select
                    v-model="addressSearch"
                    name="address_search"
                    placeholder="Start typing your address or postcode"
                    type="text"
                    autocomplete="off"
                    required
                    class="border-none p-0 max-w-lg text-gray-700"
                    :options="addressLookupOptions"
                    label="addressString"
                    @search="searchAddress"
                    @input="selectAddress"
                  >
                  </v-select>
                </div>
                <div class="text-gray-600 mt-2">
                  Please enter your billing address. If you live in the UK
                  please enter your postcode. If your address is outside the UK,
                  or does not appear upon lookup,
                  <span
                    @click="addressLine1 = ' '"
                    class="text-blue-500 cursor-pointer hover:underline hover:text-blue-800 underline"
                    >please enter it manually</span
                  >
                </div>
              </div>
              <div v-if="addressLine1">
                <!-- <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="address_number"
                    class="block text-sm font-medium text-gray-700"
                  >
                    House Number
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="addressNumber"
                      name="house_number"
                      type="text"
                      autocomplete="address_number"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    />
                  </div>
                </div> -->
                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="address_line_1"
                    class="block text-sm font-bold text-gray-700"
                  >
                    Address Line 1
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="$v.addressLine1.$model"
                      name="address_line_1"
                      type="text"
                      autocomplete="address_line_1"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                      :class="fieldStatus($v.addressLine1)"
                    />
                  </div>
                  <div
                    class="text-xs mt-1 text-red-500 font-extralight"
                    v-if="!$v.addressLine1.required && $v.addressLine1.$error"
                  >
                    You must enter the first line of your address
                  </div>
                </div>
                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="address_line_2"
                    class="block text-sm font-bold text-gray-700"
                  >
                    Address Line 2
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="addressLine2"
                      name="address_line_2"
                      type="text"
                      autocomplete="address_line_2"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    />
                  </div>
                </div>
                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="address_town"
                    class="block text-sm font-bold text-gray-700"
                  >
                    Town
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="$v.addressTown.$model"
                      name="address_town"
                      type="text"
                      autocomplete="address_town"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                      :class="fieldStatus($v.addressTown)"
                    />
                  </div>
                  <div
                    class="text-xs mt-1 text-red-500 font-extralight"
                    v-if="!$v.addressTown.required && $v.addressTown.$error"
                  >
                    You must enter your town
                  </div>
                </div>
                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="address_region"
                    class="block text-sm font-bold text-gray-700"
                  >
                    Region
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="addressRegion"
                      name="address_region"
                      type="text"
                      autocomplete="address_region"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    />
                  </div>
                </div>
                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="address_post_code"
                    class="block text-sm font-bold text-gray-700"
                  >
                    Post Code
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="$v.addressPostCode.$model"
                      name="address_post_code"
                      type="text"
                      autocomplete="post_code"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                      :class="fieldStatus($v.addressPostCode)"
                    />
                  </div>
                  <div
                    class="text-xs mt-1 text-red-500 font-extralight"
                    v-if="
                      !$v.addressPostCode.required && $v.addressPostCode.$error
                    "
                  >
                    You must enter your post code
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <!-- Stage 4 -->
          <div v-if="currentlyActiveStage.number == 4 || express">
            <transition name="fade" mode="out-in">
              <div
                v-if="express"
                class="py-2 px-6 bg-aberlour-purple text-white text-center text-xs"
              >
                <div class="">EXPRESS CHECKOUT: £{{ donationAmount }}</div>

                <div @click="expressCheckout()">
                  <div
                    class="text-white underline px-2 cursor-pointer hover:text-gray-500 mx-auto text-center my-2"
                  >
                    <div class="text-xs italic">
                      Return to standard checkout
                    </div>
                  </div>
                </div>
              </div>
            </transition>

            <transition name="fade" mode="out-in">
              <div
                class="max-w-lg space-y-4 bg-gray-200 p-4 rounded"
                v-if="express"
              >
                <svg
                  class="fill-current text-gray-900 h-10 w-20 flex-no-shrink"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 671.722 236.156"
                >
                  <title>Gift Aid</title>
                  <path
                    d="M425.721,293c18.637-29.194,9.291-33.682,8.339-33.142-18.131,10.215-31.939,40.964-30.78,51.206,1.6,14.1,12.543-2.569,22.441-18.064m70.606-26.791a53.62,53.62,0,0,0-6.419,19.5c-.477,3.424-1.033,18.3-.91,20.322a70.845,70.845,0,0,0,1.253,9.775c.443,1.611,3.206,7.4-5.661,8.623-5.218.718-5.116-12.339-5.218-14.476-.2-4.554.555-20.554,1.038-22.929.51-2.429-.507.145-1.467,1.735-2.211,3.7-4.784,8.706-7.865,13.635-4.047,6.481-13.073,21.919-25.383,21-4.605-.348-9.289-.941-11.965-13.775-1.026-4.919-.628-11.386-.523-15.268-.128-.8-.019-1.717-.688-1.343C428.159,303.18,414,333.158,398,326.419c-7.41-3.112-11.061-12.678-2.881-31.358,7.969-18.206,28.071-40.784,36.078-42.3,7.137-1.355,7.879,2.24,7.879,2.24.651-1.327,5.1-1.171,6.073.732,1.3,2.545,2.168,2.986,1.3,9.7-.491,3.872-4.088,28.092-3.467,36.414.286,3.9.955,13.509,4.919,13.972,6.924.829,15.315-13.9,16.268-15.439,1.865-3.009,16.805-28.056,18.644-31.713,1.979-3.943,3.23-6.822,4.507-9.332s5.126-2.789,8.481-.5S497.476,264.27,496.327,266.211ZM180.189,278.478c-8.784.946-24.8,22.18-28.1,29.721-3.374,7.7-4.592,15.123-.588,18.22,8.285,6.433,16.856-4.472,19.375-7.007,1.559-1.56,12.459-13.45,15.2-25.526C187.888,285.912,188.727,277.564,180.189,278.478Zm4.578,94.246q-.909,1.625-1.869,3.221c-6.472,10.744-14.962,20.331-25.489,27.241-14.258,9.356-27.649,12.95-42.611,12.77-8.7-.1-17.09-1.509-24.244-6.059-5.864-3.73-6.7-9.562-4.924-13.412,2.469-5.363,10.176-4.841,13.455-1.763,8.187,7.677,13.074,10.654,23.6,10.144a56.707,56.707,0,0,0,24.69-7.26c43.542-25.427,43.144-71.137,44.912-98.68.187-1.675-.723-.457-1.031.455a108.567,108.567,0,0,1-7.775,16.943,58.19,58.19,0,0,1-18.424,20.1c-5.514,3.642-14.469,5.405-20.775,1.294-2.286-1.5-15.654-9.325-4.324-32.638,7.125-14.668,22.118-24.843,25.5-27,8.27-5.282,14.18-7.794,20.377-7.318,3.156.23,3.611,1.472,5.957,1.41,1.336-1.568,2.073-2.72,4.27-3.327,2.95-.471,6.453,2,7.8,6.683s-2.161,12.206-3.047,15.824C200.822,291.35,203.938,338.277,184.767,372.724Zm49.607-105.731c-5.337.1-4.9,3.952-6.019,7.322-1.083,3.36-10.28,33.575-11.448,38.992s-1.969,10.282-.28,17.716c1.718,7.6,10.429,5.379,11.353,4.045,4.256-5.96.486-7.716.349-11.879-.109-4.351,1.082-8.915,1.981-14.806.32-2.1.962-11.649,1.277-12.945.355-1.4,3.36-12.033,7.689-18.5C241.129,274.166,242.76,266.848,234.374,266.993ZM248.9,231.656c-.73-1.5-4.7-6.225-9.882-2.557-7.708,5.458,1.18,13,2.607,16.7s9.132,6.8,8.007-.5C249.468,244.249,251.02,236,248.9,231.656Zm85.108,35.59c-2.509.559-7.516,1.569-10.666,2.1-4.77.8-7.369,3.8-7.189,6.832.18,3.054,1.225,4.493,5.481,3.685,3.848-.728,7.132-4,10.5-4.014,0,0-6.954,29.319-7.409,33.248s-2.512,14.678,1.713,20.777c9.4,13.576,28.2-1.985,29.957-3.68,1.291-1.253,13.168-11.668,17.194-20.021,2.04-4.239-1.433-5.175-3.784-6.04s-7.318.63-8.012,3.73c-1.512,6.734-17.96,24.9-26.1,21.258-9.594-4.3,7.713-52.479,7.713-52.479,2.064-.926,12.517-3.62,22.413-6.165,11.417-2.925,46.312-9.815,38.436-20.24-3.854-5.1-13.816,2.666-17.192,4.292-12.095,5.8-41.7,14.315-41.7,14.315s3.844-17.32,5.088-20.732c1.429-3.905,6.7-6.46,7.467-13.412.905-8.086-8.835-11.768-13.484-2.915-.962,1.817-2.287,6.832-2.417,6.957-1.249,1.2-12,5.493-22.571,10.533-3.332,1.588-22.256,8.469-22.291,8.424.026-.144,5.746-18.281,12.374-33.412,4.41-10.061,10.623-24.066,21.63-26.909,10.308-2.657,5.448,8.08,10.086,10.871,5.883,3.538,9.492-.924,10.393-5.191.706-3.342.519-20.879-17.31-19.126-16.965,1.673-30.484,27.571-47.2,75.964-.18.194-13.457,8.77-24.464,10.974-5.443,1.088-7.851,1.559-8.571,3.5a8.571,8.571,0,0,0,2,9.168c3.137,3.744,27.646-12.479,27.62-12.367-.5.661-20.609,77.281-20.77,78.175-1.159,6.381-7.642,23.206-7.291,30.843.194,3.929,1.734,12.107,7.391,11.742,11.846.777,9.561-15.865,8.765-18.917-1.659-6.313,6.851-48.045,14.488-78.8,1.557-6.273,4.756-16.566,5.313-19.014a11.455,11.455,0,0,1,6.22-8.233s42.583-20.073,42.979-19.957C340.811,243.054,334.008,267.246,334.008,267.246Zm291.747,38.3C634,313.343,642.2,308.4,646.421,305c12.945-10.41,39.635-57.853,39.635-57.853.152,1.588-11.121,56,3.95,62.033,9.664,3.86,32.156-15.33,34.732-17.107,14.851-10.251,5.751-14,2.886-14-7.658-.024-6.279,5.521-8.374,8.011-3.455,4.114-17.341,18.4-24.14,14.607-3.661-2.052-2.758-14.14-2.393-16.926,2.14-28.8,2.711-34,4.389-40.624.94-3.682,5.426-3.585,8.173-4.089,37.08-6.851,43.732-4.088,48.355-6.342,3.67-1.805,4.327-9.575-.879-11.246-2.382-.749-5.4,1.064-10.858,3.1-5.431,2.007-32.791,8.057-36.815,8.654-3.706.536-4.5.014-5.4-1.147-.886-1.149.82-14.663,6.135-25.865,2.313-4.848,2.374-12.267-5.178-12.841-3.106-.223-5.744.661-6.924,3.308-1.175,2.63-3.438,26.63-3.967,28.228-.535,1.578-3.4,2.81-4.033,5.549s-.192,4.448-2.035,5.064c-1.863.633-6.965,1.123-9.064,1.628-2.209.538-3.519,4.763-3.6,7.206s3.86.991,5.761.714c2.17-.316,7.476-2.967,3.7,1.578-1.431,1.737-27.17,41.973-37.222,50.258-11.566,9.521-10.739-9.2-10.45-12.389,1.748-19.092,10.1-31.9,11.3-34.94,1.18-3.055,1.677-12.107-8.183-10.107a6.979,6.979,0,0,0-4.938,4.637.992.992,0,0,0-.029.2C629.964,253.222,612.841,293.331,625.755,305.549Zm15.029-93.416c3.038,5.924,8.229,3.829,9.113,2.3.887-1.517,1.595-1.832,4.112-2.846,4.621-1.846-3.358-10.14-10.948-7.8a2.9,2.9,0,0,0-1.737,2.466C641.53,207.986,639.75,210.149,640.784,212.133ZM547.7,258.685s4.981-4.292,7.09-4.181c.979.048-.728,2.759,2.694,4.434,1.818.9-1.988,13.007-9.512,24.628-17.279,26.682-25.471,25.478-26.182,17.374C520.329,284.033,542.689,262.128,547.7,258.685Zm8.772,21.876s-.064,5.749.384,10.664c.4,4.412,1.908,13.644,3.462,16.63,2.408,4.6,7.514,4.6,11.446,2.346,5.147-2.957,2.713-8.488.753-10.329-1.711-1.621-5.869-3.7-7.128-10.645-.741-4.111-.135-22.637,1.083-29.118a86.628,86.628,0,0,1,5.621-17.3c2.05-4.045,14.4-27.206,14.581-34.981.075-3.393-3.42-6.206-9.131-5.618s-7.132,5.161-7.142,8.159c-.014,2.981-6.061,23.973-6.374,24.928-.5,1.434-1.491,10.029-4.441,10.048a28.671,28.671,0,0,0-18.159,6.078c-2.846,2.156-12.509,9.673-18.087,17.516-2.531,3.55-14.038,18.342-12.737,36,1.185,16.056,12.419,13.215,15.642,12.7,14.661-2.355,24.969-26.469,26.462-29.426C555.348,282.964,554.455,284.376,556.471,280.561ZM498.716,221.9c-1.074,1.32-.806,5.509,1.533,7.675,1.761,1.633,2.007,1.934,2.064,3.254.1,2.434,1.654,2.569,4.047,2.535,2.927-.042,5.32-2.073,5.616-6.206s-3.708-7.668-6.931-8.464S500.109,220.173,498.716,221.9Z"
                    transform="translate(-84.802 -179.806)"
                  />
                </svg>
                <div class="w-full mb-3 mt-3">
                  <transition name="fade" mode="out-in">
                    <p
                      key="1"
                      v-if="donationAmount > 0 && giftAid"
                      class="w-full font-semibold lg:text-lg text-sm"
                    >
                      Claiming Gift Aid
                      <span class="underline font-extrabold text-green-500"
                        >WILL</span
                      >
                      turn £{{ donationAmount }} into £{{
                        singleDonationGiftAidAmount
                      }}
                    </p>
                    <p
                      key="2"
                      v-else
                      class="w-full font-semibold text-gray-700 lg:text-lg text-sm"
                    >
                      <!-- <i
                    class="far fa-star-exclamation mr-2 text-aberlour-purple opacity-75"
                  ></i> -->

                      Claiming Gift Aid would turn £{{
                        donationAmount ? donationAmount : 0
                      }}
                      into £{{ singleDonationGiftAidAmount }}
                    </p>
                  </transition>

                  <div class="w-full font-semibold text-gray-400 text-xs">
                    at no extra cost to you.
                  </div>
                </div>

                <div class="relative flex items-start">
                  <div class="flex items-center h-5">
                    <input
                      v-model="giftAid"
                      id="gift_aid"
                      name="gift_aid"
                      type="checkbox"
                      class="focus:ring-aberlour-purple h-6 w-6 text-aberlour-purple border-gray-300 rounded cursor-pointer"
                    />
                  </div>

                  <div class="ml-3">
                    <label for="gift_aid" class="font-semibold text-gray-700"
                      >I want to gift aid my donation
                    </label>
                  </div>
                </div>
                <div
                  @click="giftAidReadMore = !giftAidReadMore"
                  class="cursor-pointer text-blue-500 underline hover:text-blue-800"
                >
                  Read More
                </div>
                <p v-if="giftAidReadMore" class="text-gray-500 w-full">
                  Yes, I am a UK taxpayer and I would like Aberlour to treat all
                  donations I have made in the past four years and all donations
                  I make in the future as Gift Aid donations until I notify you
                  otherwise. I understand that if I pay less Income Tax and/or
                  Capital Gains Tax than the amount of Gift Aid claimed on all
                  my donations in the relevant tax year it is my responsibility
                  to pay any difference. Please phone us on 0800 0856150 if your
                  details or tax status change.
                </p>
              </div>
            </transition>

            <transition name="fade" mode="out-in">
              <div class="text-gray-600">
                <p>
                  We would love to keep you posted with news of our work,
                  events, campaigns and appeals by email and text.
                </p>
                <br />
                <p>
                  Please tell us if you are happy for us to contact you by:
                  <br />
                  (Select all that apply – even if you already receive updates from us)
                </p>

                <div class="mt-4">
                  <!-- @todo - split these out into a marketing pref component -->
                  <!--email pref -->
                  <div
                    @click="toggleSwitch('Email')"
                    class="py-2 text-center cursor-pointer grid-cols-4 grid"
                  >
                    <div class="font-semibold pb-1 mr-9">
                      <i class="fas fa-envelope mr-2"></i>Email
                    </div>
                    <button
                      type="button"
                      :class="
                        marketingPrefEmail
                          ? 'bg-aberlour-purple'
                          : 'bg-gray-200'
                      "
                      class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-aberlour-purple"
                      aria-pressed="false"
                    >
                      <span class="sr-only">Email Preference</span>
                      <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
                      <span
                        :class="
                          marketingPrefEmail ? 'translate-x-5' : 'translate-x-0'
                        "
                        class="pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                      >
                        <!-- Enabled: "opacity-0 ease-out duration-100", Not Enabled: "opacity-100 ease-in duration-200" -->
                        <span
                          :class="
                            marketingPrefEmail
                              ? 'opacity-0 ease-out duration-100'
                              : 'opacity-100 ease-in duration-200'
                          "
                          class="absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                          aria-hidden="true"
                        >
                          <svg
                            class="bg-white h-3 w-3 text-gray-400"
                            fill="none"
                            viewBox="0 0 12 12"
                          >
                            <path
                              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                        <!-- Enabled: "opacity-100 ease-in duration-200", Not Enabled: "opacity-0 ease-out duration-100" -->
                        <span
                          :class="
                            marketingPrefEmail
                              ? 'opacity-100 ease-in duration-200'
                              : 'opacity-0 ease-out duration-100'
                          "
                          class="absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                          aria-hidden="true"
                        >
                          <svg
                            class="bg-white h-3 w-3 text-aberlour-purple"
                            fill="currentColor"
                            viewBox="0 0 12 12"
                          >
                            <path
                              d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
                            />
                          </svg>
                        </span>
                      </span>
                    </button>
                  </div>

                  <!--text pref -->
                  <div
                    @click="toggleSwitch('Text')"
                    class="py-2 text-center cursor-pointer flex grid-cols-4 grid"
                  >
                    <div class="font-semibold mr-12">
                      <i class="fad fa-comments-alt mr-2"></i>Text
                    </div>
                    <button
                      type="button"
                      :class="
                        marketingPrefText ? 'bg-aberlour-purple' : 'bg-gray-200'
                      "
                      class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-aberlour-purple"
                      aria-pressed="false"
                    >
                      <span class="sr-only">Text Preference</span>
                      <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
                      <span
                        :class="
                          marketingPrefText ? 'translate-x-5' : 'translate-x-0'
                        "
                        class="pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                      >
                        <!-- Enabled: "opacity-0 ease-out duration-100", Not Enabled: "opacity-100 ease-in duration-200" -->
                        <span
                          :class="
                            marketingPrefText
                              ? 'opacity-0 ease-out duration-100'
                              : 'opacity-100 ease-in duration-200'
                          "
                          class="absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                          aria-hidden="true"
                        >
                          <svg
                            class="bg-white h-3 w-3 text-gray-400"
                            fill="none"
                            viewBox="0 0 12 12"
                          >
                            <path
                              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                        <!-- Enabled: "opacity-100 ease-in duration-200", Not Enabled: "opacity-0 ease-out duration-100" -->
                        <span
                          :class="
                            marketingPrefText
                              ? 'opacity-100 ease-in duration-200'
                              : 'opacity-0 ease-out duration-100'
                          "
                          class="absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                          aria-hidden="true"
                        >
                          <svg
                            class="bg-white h-3 w-3 text-aberlour-purple"
                            fill="currentColor"
                            viewBox="0 0 12 12"
                          >
                            <path
                              d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
                            />
                          </svg>
                        </span>
                      </span>
                    </button>
                  </div>
                </div>

                <div class="mt-4">
                  <p>
                    We will contact you by post and phone, unless you tell us
                    otherwise. We will send you news, campaigns and fundraising
                    appeals.
                  </p>

                  <div class="mt-4 flex items-center">
                    <input
                      name="marketing_pref_post"
                      v-model="marketingPrefPost"
                      type="checkbox"
                      class="cursor-pointer focus:ring-aberlour-purple h-4 w-4 text-aberlour-purple border-gray-300"
                    />

                    <div class="ml-3">
                      No thank you, I would rather not receive post from you.
                    </div>
                  </div>

                  <div class="mt-2 flex items-center">
                    <input
                      name="marketing_pref_post"
                      v-model="marketingPrefPhone"
                      type="checkbox"
                      class="cursor-pointer focus:ring-aberlour-purple h-4 w-4 text-aberlour-purple border-gray-300"
                    />

                    <div class="ml-3">
                      No thank you, I would rather not receive calls from you.
                    </div>
                  </div>

                  <div class="mt-4 text-sm text-gray-400">
                    If you’d like to change how we contact you in the future,
                    please contact our team by emailing
                    <a
                      class="text-blue-500 underline"
                      href="mailto:hello@aberlour.org.uk"
                      >hello@aberlour.org.uk</a
                    >
                    or by calling
                    <span class="text-blue-500 underline">0141 260 9190</span>.
                    We promise to keep your details safe and never sell them or
                    swap them with anyone. View our
                    <a
                      class="text-blue-500 underline"
                      href="https://www.aberlour.org.uk/privacy-policy/#:~:text=Aberlour%20holds%20basic%20personal%20information,our%20support%20meets%20your%20needs."
                      target="_new"
                      >privacy policy</a
                    >
                    for more information.
                  </div>
                  <div v-if="express">
                    <payment-request-button
                      class="mt-4"
                      :stripe="stripeKey"
                      :options="paymentRequestOptions"
                      @paymentMethodCreated="expressPay"
                    />
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <!-- Stage 5 -->
          <transition name="fade" mode="out-in">
            <div v-if="currentlyActiveStage.number == 5">
              <div class="max-w-lg space-y-4 bg-yellow-200 border-aberlour-yellow border-2 shadow-md p-4 rounded">
                <svg
                  class="fill-current text-gray-900 h-10 w-20 flex-no-shrink"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 671.722 236.156"
                >
                  <title>Gift Aid</title>
                  <path
                    d="M425.721,293c18.637-29.194,9.291-33.682,8.339-33.142-18.131,10.215-31.939,40.964-30.78,51.206,1.6,14.1,12.543-2.569,22.441-18.064m70.606-26.791a53.62,53.62,0,0,0-6.419,19.5c-.477,3.424-1.033,18.3-.91,20.322a70.845,70.845,0,0,0,1.253,9.775c.443,1.611,3.206,7.4-5.661,8.623-5.218.718-5.116-12.339-5.218-14.476-.2-4.554.555-20.554,1.038-22.929.51-2.429-.507.145-1.467,1.735-2.211,3.7-4.784,8.706-7.865,13.635-4.047,6.481-13.073,21.919-25.383,21-4.605-.348-9.289-.941-11.965-13.775-1.026-4.919-.628-11.386-.523-15.268-.128-.8-.019-1.717-.688-1.343C428.159,303.18,414,333.158,398,326.419c-7.41-3.112-11.061-12.678-2.881-31.358,7.969-18.206,28.071-40.784,36.078-42.3,7.137-1.355,7.879,2.24,7.879,2.24.651-1.327,5.1-1.171,6.073.732,1.3,2.545,2.168,2.986,1.3,9.7-.491,3.872-4.088,28.092-3.467,36.414.286,3.9.955,13.509,4.919,13.972,6.924.829,15.315-13.9,16.268-15.439,1.865-3.009,16.805-28.056,18.644-31.713,1.979-3.943,3.23-6.822,4.507-9.332s5.126-2.789,8.481-.5S497.476,264.27,496.327,266.211ZM180.189,278.478c-8.784.946-24.8,22.18-28.1,29.721-3.374,7.7-4.592,15.123-.588,18.22,8.285,6.433,16.856-4.472,19.375-7.007,1.559-1.56,12.459-13.45,15.2-25.526C187.888,285.912,188.727,277.564,180.189,278.478Zm4.578,94.246q-.909,1.625-1.869,3.221c-6.472,10.744-14.962,20.331-25.489,27.241-14.258,9.356-27.649,12.95-42.611,12.77-8.7-.1-17.09-1.509-24.244-6.059-5.864-3.73-6.7-9.562-4.924-13.412,2.469-5.363,10.176-4.841,13.455-1.763,8.187,7.677,13.074,10.654,23.6,10.144a56.707,56.707,0,0,0,24.69-7.26c43.542-25.427,43.144-71.137,44.912-98.68.187-1.675-.723-.457-1.031.455a108.567,108.567,0,0,1-7.775,16.943,58.19,58.19,0,0,1-18.424,20.1c-5.514,3.642-14.469,5.405-20.775,1.294-2.286-1.5-15.654-9.325-4.324-32.638,7.125-14.668,22.118-24.843,25.5-27,8.27-5.282,14.18-7.794,20.377-7.318,3.156.23,3.611,1.472,5.957,1.41,1.336-1.568,2.073-2.72,4.27-3.327,2.95-.471,6.453,2,7.8,6.683s-2.161,12.206-3.047,15.824C200.822,291.35,203.938,338.277,184.767,372.724Zm49.607-105.731c-5.337.1-4.9,3.952-6.019,7.322-1.083,3.36-10.28,33.575-11.448,38.992s-1.969,10.282-.28,17.716c1.718,7.6,10.429,5.379,11.353,4.045,4.256-5.96.486-7.716.349-11.879-.109-4.351,1.082-8.915,1.981-14.806.32-2.1.962-11.649,1.277-12.945.355-1.4,3.36-12.033,7.689-18.5C241.129,274.166,242.76,266.848,234.374,266.993ZM248.9,231.656c-.73-1.5-4.7-6.225-9.882-2.557-7.708,5.458,1.18,13,2.607,16.7s9.132,6.8,8.007-.5C249.468,244.249,251.02,236,248.9,231.656Zm85.108,35.59c-2.509.559-7.516,1.569-10.666,2.1-4.77.8-7.369,3.8-7.189,6.832.18,3.054,1.225,4.493,5.481,3.685,3.848-.728,7.132-4,10.5-4.014,0,0-6.954,29.319-7.409,33.248s-2.512,14.678,1.713,20.777c9.4,13.576,28.2-1.985,29.957-3.68,1.291-1.253,13.168-11.668,17.194-20.021,2.04-4.239-1.433-5.175-3.784-6.04s-7.318.63-8.012,3.73c-1.512,6.734-17.96,24.9-26.1,21.258-9.594-4.3,7.713-52.479,7.713-52.479,2.064-.926,12.517-3.62,22.413-6.165,11.417-2.925,46.312-9.815,38.436-20.24-3.854-5.1-13.816,2.666-17.192,4.292-12.095,5.8-41.7,14.315-41.7,14.315s3.844-17.32,5.088-20.732c1.429-3.905,6.7-6.46,7.467-13.412.905-8.086-8.835-11.768-13.484-2.915-.962,1.817-2.287,6.832-2.417,6.957-1.249,1.2-12,5.493-22.571,10.533-3.332,1.588-22.256,8.469-22.291,8.424.026-.144,5.746-18.281,12.374-33.412,4.41-10.061,10.623-24.066,21.63-26.909,10.308-2.657,5.448,8.08,10.086,10.871,5.883,3.538,9.492-.924,10.393-5.191.706-3.342.519-20.879-17.31-19.126-16.965,1.673-30.484,27.571-47.2,75.964-.18.194-13.457,8.77-24.464,10.974-5.443,1.088-7.851,1.559-8.571,3.5a8.571,8.571,0,0,0,2,9.168c3.137,3.744,27.646-12.479,27.62-12.367-.5.661-20.609,77.281-20.77,78.175-1.159,6.381-7.642,23.206-7.291,30.843.194,3.929,1.734,12.107,7.391,11.742,11.846.777,9.561-15.865,8.765-18.917-1.659-6.313,6.851-48.045,14.488-78.8,1.557-6.273,4.756-16.566,5.313-19.014a11.455,11.455,0,0,1,6.22-8.233s42.583-20.073,42.979-19.957C340.811,243.054,334.008,267.246,334.008,267.246Zm291.747,38.3C634,313.343,642.2,308.4,646.421,305c12.945-10.41,39.635-57.853,39.635-57.853.152,1.588-11.121,56,3.95,62.033,9.664,3.86,32.156-15.33,34.732-17.107,14.851-10.251,5.751-14,2.886-14-7.658-.024-6.279,5.521-8.374,8.011-3.455,4.114-17.341,18.4-24.14,14.607-3.661-2.052-2.758-14.14-2.393-16.926,2.14-28.8,2.711-34,4.389-40.624.94-3.682,5.426-3.585,8.173-4.089,37.08-6.851,43.732-4.088,48.355-6.342,3.67-1.805,4.327-9.575-.879-11.246-2.382-.749-5.4,1.064-10.858,3.1-5.431,2.007-32.791,8.057-36.815,8.654-3.706.536-4.5.014-5.4-1.147-.886-1.149.82-14.663,6.135-25.865,2.313-4.848,2.374-12.267-5.178-12.841-3.106-.223-5.744.661-6.924,3.308-1.175,2.63-3.438,26.63-3.967,28.228-.535,1.578-3.4,2.81-4.033,5.549s-.192,4.448-2.035,5.064c-1.863.633-6.965,1.123-9.064,1.628-2.209.538-3.519,4.763-3.6,7.206s3.86.991,5.761.714c2.17-.316,7.476-2.967,3.7,1.578-1.431,1.737-27.17,41.973-37.222,50.258-11.566,9.521-10.739-9.2-10.45-12.389,1.748-19.092,10.1-31.9,11.3-34.94,1.18-3.055,1.677-12.107-8.183-10.107a6.979,6.979,0,0,0-4.938,4.637.992.992,0,0,0-.029.2C629.964,253.222,612.841,293.331,625.755,305.549Zm15.029-93.416c3.038,5.924,8.229,3.829,9.113,2.3.887-1.517,1.595-1.832,4.112-2.846,4.621-1.846-3.358-10.14-10.948-7.8a2.9,2.9,0,0,0-1.737,2.466C641.53,207.986,639.75,210.149,640.784,212.133ZM547.7,258.685s4.981-4.292,7.09-4.181c.979.048-.728,2.759,2.694,4.434,1.818.9-1.988,13.007-9.512,24.628-17.279,26.682-25.471,25.478-26.182,17.374C520.329,284.033,542.689,262.128,547.7,258.685Zm8.772,21.876s-.064,5.749.384,10.664c.4,4.412,1.908,13.644,3.462,16.63,2.408,4.6,7.514,4.6,11.446,2.346,5.147-2.957,2.713-8.488.753-10.329-1.711-1.621-5.869-3.7-7.128-10.645-.741-4.111-.135-22.637,1.083-29.118a86.628,86.628,0,0,1,5.621-17.3c2.05-4.045,14.4-27.206,14.581-34.981.075-3.393-3.42-6.206-9.131-5.618s-7.132,5.161-7.142,8.159c-.014,2.981-6.061,23.973-6.374,24.928-.5,1.434-1.491,10.029-4.441,10.048a28.671,28.671,0,0,0-18.159,6.078c-2.846,2.156-12.509,9.673-18.087,17.516-2.531,3.55-14.038,18.342-12.737,36,1.185,16.056,12.419,13.215,15.642,12.7,14.661-2.355,24.969-26.469,26.462-29.426C555.348,282.964,554.455,284.376,556.471,280.561ZM498.716,221.9c-1.074,1.32-.806,5.509,1.533,7.675,1.761,1.633,2.007,1.934,2.064,3.254.1,2.434,1.654,2.569,4.047,2.535,2.927-.042,5.32-2.073,5.616-6.206s-3.708-7.668-6.931-8.464S500.109,220.173,498.716,221.9Z"
                    transform="translate(-84.802 -179.806)"
                  />
                </svg>
                <div class="w-full mb-3 mt-3">
                  <transition name="fade" mode="out-in">
                    <p
                      key="1"
                      v-if="donationAmount > 0 && giftAid"
                      class="w-full font-semibold lg:text-lg text-sm"
                    >
                      Claiming Gift Aid
                      <span class="underline font-extrabold text-green-500"
                        >WILL</span
                      >
                      turn £{{ donationAmount }} into £{{
                        singleDonationGiftAidAmount
                      }}
                    </p>
                    <p
                      key="2"
                      v-else
                      class="w-full font-semibold lg:text-lg text-sm underline text-red-500"
                    >
                      <!-- <i
                    class="far fa-star-exclamation mr-2 text-aberlour-purple opacity-75"
                  ></i> -->

                      Claiming Gift Aid would turn £{{
                        donationAmount ? donationAmount : 0
                      }}
                      into £{{ singleDonationGiftAidAmount }}
                    </p>
                  </transition>

                  <div class="w-full font-semibold text-gray-400 text-xs">
                    at no extra cost to you.
                  </div>
                </div>

                <div class="relative flex items-start">
                  <div class="flex items-center h-5">
                    <input
                      v-model="giftAid"
                      id="gift_aid"
                      name="gift_aid"
                      type="checkbox"
                      class="focus:ring-aberlour-purple h-6 w-6 text-aberlour-purple border-gray-300 rounded cursor-pointer"
                    />
                  </div>

                  <div class="ml-3">
                    <label for="gift_aid" class="font-semibold text-gray-700"
                      >I want to gift aid my donation
                    </label>
                  </div>
                </div>
                <div
                  @click="giftAidReadMore = !giftAidReadMore"
                  class="cursor-pointer text-blue-500 underline hover:text-blue-800"
                >
                  Read More
                </div>
                <p v-if="giftAidReadMore" class="text-gray-500 w-full">
                  Yes, I am a UK taxpayer and I would like Aberlour to treat all
                  donations I have made in the past four years and all donations
                  I make in the future as Gift Aid donations until I notify you
                  otherwise. I understand that if I pay less Income Tax and/or
                  Capital Gains Tax than the amount of Gift Aid claimed on all
                  my donations in the relevant tax year it is my responsibility
                  to pay any difference. Please phone us on 0800 0856150 if your
                  details or tax status change.
                </p>
              </div>

              <div
                @click="paymentMethod = null"
                v-if="donationType == 'Single Donation'"
                class="mt-3 font-semibold text-gray-700 cursor-pointer hover:underline"
              >
                <!-- <i
                  class="fad fa-lock-alt text-aberlour-purple mr-2 opacity-75"
                ></i> -->
                <span v-if="!paymentMethod">How would you like to pay?</span
                ><span v-else></span>
              </div>
              <div v-else class="mt-3">
                <div><strong>Your direct debit instruction</strong></div>
                <div>
                  Instruction to your bank or building society to pay by Direct
                  Debit
                </div>
                <img
                  src="/img/other/logos/direct-debit-logo.png"
                  width="90px"
                  class="mt-4"
                />
              </div>
            </div>
          </transition>
        </div>

        <transition name="fade" mode="out-in">
          <!-- Payment and Progress buttons -->
          <div
            class="pb-4"
            :class="currentlyActiveStage.number > 1 ? 'px-4' : ''"
          >
            <!-- Single Payment -->
            <div
              v-if="
                currentlyActiveStage.number == 5 &&
                !paymentMethod &&
                donationType == 'Single Donation'
              "
            >
              <!-- Credit Card Button -->
              <button
                @click="paymentMethod = 'credit-debit-card'"
                :disabled="complete"
                :class="
                  complete
                    ? 'bg-purple-300 cursor-not-allowed text-white'
                    : 'hover:bg-aberlour-purple cursor-pointer text-gray-800 hover:text-white'
                "
                class="w-full flex justify-center py-3 px-5 border border-gray-500 rounded-md shadow-sm text-sm font-semibold mb-4"
              >
                Pay by credit/debit Card
              </button>
            </div>

            <paypal-button
              v-if="
                currentlyActiveStage.number == 5 &&
                donationType == 'Single Donation'
              "
              :total="donationAmount"
              :donationInfo="donationInfo"
            ></paypal-button>

            <!-- Paypal Button -->
            <!-- this needs the element to be initialised on page load -->

            <payment-request-button
              v-if="
                currentlyActiveStage.number == 5 &&
                donationType == 'Single Donation'
              "
              class="my-4"
              :stripe="stripeKey"
              :options="paymentRequestOptions"
              @paymentMethodCreated="expressPay"
            />
            <div
              class=""
              :class="
                currentlyActiveStage.number == 5 && !paymentMethod
                  ? 'flex-inline'
                  : 'hidden'
              "
              id="paypal-button-container"
            ></div>

            <div
              v-if="
                currentlyActiveStage.number == 5 &&
                !paymentMethod &&
                donationType == 'Single Donation'
              "
            ></div>

            <div
              v-if="
                currentlyActiveStage.number == 5 &&
                !paymentMethod &&
                donationType == 'Monthly Donation'
              "
            >
              <!--
                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="dd_payment_date"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Choose your payment date
                  </label>
                    <v-select
                    v-model="ddPaymentDate"
                    name="dd_payment_date"
                    placeholder="Select preferred day of month for payment"
                    type="text"
                    autocomplete="off"
                    required
                    class="border-none p-0 max-w-lg shadow-sm focus:ring-aberlour-focus-blue"
                    :options="preferredPaymentDays"
                    label="addressString"
                  >
                  </v-select>
                </div> -->
              <!--
                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="dd_account_holder_name"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Account Holder Name
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="ddAccountHolderName"
                      name="dd_account_holder_name"
                      type="text"
                      autocomplete="off"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    />
                  </div>
                </div> -->

              <!-- <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="dd_account_number"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Account Number
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="ddAccountNumber"
                      name="dd_account_number"
                      type="text"
                      autocomplete="off"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    />
                  </div>
                </div> -->

              <!-- <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="dd_sort_code"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Sort Code
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="ddSortCode"
                      name="dd_sort_code"
                      type="text"
                      autocomplete="off"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    />
                  </div>
                </div> -->

              <p class="text-center text-xs font-thin mt-3">
                <i class="fas fa-info-circle mr-2 text-blue-800"></i>By clicking
                'Set up direct debit', you agree to our
                <a
                  class="text-blue-500 underline"
                  href="https://www.aberlour.org.uk/privacy-policy/#:~:text=Aberlour%20holds%20basic%20personal%20information,our%20support%20meets%20your%20needs."
                  target="_new"
                  >privacy policy</a
                >
              </p>

              <div
                @click="recaptcha"
                class="mt-4 rounded-md shadow-md py-3 text-xl text-center w-full"

                 :class="
                  payButtonDisabled
                    ? 'cursor-not-allowed bg-gray-400  hover:bg-gray-400'
                    : ' bg-aberlour-green text-white font-semibold cursor-pointer hover:bg-green-700'
                "
              >
            
              <i
                  aria-hidden="true"
                  :class="
                    payButtonDisabled
                      ? 'fas fa-circle-notch fa-spin mr-2'
                      : 'fas fa-lock-alt mr-2'
                  "
                ></i> Set up
                Direct Debit
              </div>
              <div class="w-full">
                <div
                  class="text-gray-500 items-center flex mt-4 justify-center"
                >
                  <p>Payment powered by</p>
                  <i class="fab fa-cc-stripe text-2xl ml-1"></i>
                </div>
              </div>
            </div>

            <div v-if="nextStage && !paymentMethod && !express">
              <div
                @click="stageManager(nextStage)"
                class="rounded-md shadow-md py-3 md:text-xl mx-auto w-full mt-1 pl-0 sm:pl-10 text-white font-semibold text-center flex relative"
                :class="
                  (this.$v.donorValidationGroup.$invalid &&
                    this.currentlyActiveStage.number == 2) ||
                  (this.$v.addressValidationGroup.$invalid &&
                    this.currentlyActiveStage.number == 3) ||
                  this.donationAmount == 'Other'
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-aberlour-green cursor-pointer hover:bg-green-700'
                "
              >
                <div class="mx-auto w-full">
                  Continue - {{ nextStage.title }}
                </div>
                <div class="absolute right-4">
                  <i
                    class="pt-1 far fa-arrow-circle-right float-right mr-5 pt-1 hidden md:inline-block"
                  ></i>
                </div>
              </div>
              <!-- here to trigger the can make payment api -->
              <payment-request-button
                :class="
                  expressCheckoutAvailable &&
                  express &&
                  currentlyActiveStage.number == 4
                    ? ''
                    : 'hidden'
                "
                class="mt-4"
                :stripe="stripeKey"
                :options="paymentRequestOptions"
                @paymentMethodCreated="expressPay"
              />

              <div
                v-if="
                  currentlyActiveStage.number == 1 &&
                  donationType != 'Monthly Donation' &&
                  expressCheckoutAvailable
                "
              >
                <div class="w-full flex mt-3">
                  <div class="col-span-4 w-2/5 min-h-full">
                    <div class="h-1/2 border-b border-gray-400"></div>
                  </div>
                  <div class="text-center text-lg align-bottom w-1/5">or</div>
                  <div class="col-span-4 w-2/5 min-h-full mt-2">
                    <div class="h-1/2 border-b border-gray-400"></div>
                  </div>
                </div>
                <div
                  v-if="expressCheckout"
                  class="cursor-pointer text-blue-500 hover:text-blue-600"
                  @click="expressCheckout()"
                >
                  <div
                    class="w-full text-center underline inline-block align-middle"
                  >
                    Express Checkout
                  </div>
                  <div class="flex w-full">
                    <div class="mx-auto">
                      <i class="fab fa-apple-pay fa-2x mx-1"></i>
                      <i class="fab fa-google-pay fa-2x mx-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- debit & credit card payment section -->
            <div
              v-if="
                currentlyActiveStage.number == 5 &&
                paymentMethod == 'credit-debit-card'
              "
            >
              <!-- card placeholder div -->
              <!-- <div
                id="card-element"
                class="p-4 mt-2 mb-2 border-t border-gray-200"
              ></div> -->

              <!-- <div class="mt-8 sm:mx-auto sm:w-full">
                  <label
                    for="card_number"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Card Number

                  </label>
                  <div class="flex items-center border-gray-500 border rounded-md placeholder-gray-400 ">
                    <div id="card-number-element"
                    type=""
                    class="block w-full px-3">
                  </div>
                    <span class="brand"><i :class="'fa '+ ccBrand +' text-2xl mr-3 text-gray-500'" id="brand-icon"></i></span>

                  </div>
                </div>


                 <div class="mt-8 sm:mx-auto sm:w-full">
                  <label
                    for="card_Expiry"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Expiry Date
                  </label>
                  <div class="w-1/2 flex items-center border-gray-500 border rounded-md placeholder-gray-400 ">
                    <div id="card-expiry-element" class="block w-full px-3"></div>
                  </div>
                </div>


                 <div class="mt-8 sm:mx-auto sm:w-full">
                  <label
                    for="card_number"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Security Code (CVC)
                  </label>
                  <div class="w-1/2 flex items-center border-gray-500 border rounded-md placeholder-gray-400 ">
                    <div id="card-cvc-element" class="block w-full px-3"></div>
                  </div>
                </div>

                <div class="mt-8 sm:mx-auto sm:w-full">
                  <label
                    for="address_number"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Post Code
                  </label>
                  <div class="max-w-lg flex rounded-md shadow-sm">
                    <input
                      v-model="addressPostCode"
                      name="address_post_code"
                      type="text"
                      autocomplete="post_code"
                      required
                      class="block w-full border-gray-300 rounded-md placeholder-gray-400 sm:text-sm focus:outline-none focus:ring-2 focus:ring-aberlour-focus-blue focus:border-transparent"
                    />
                  </div>
                </div> -->

              <div class="flex text-4xl text-gray-600 space-x-4">
                <i class="fab fa-cc-visa"></i>
                <i class="fab fa-cc-mastercard"></i>
                <i class="fab fa-cc-amex"></i>
              </div>

              <StripeElements
                :stripe-key="stripeKey"
                :instance-options="instanceOptions"
                :elements-options="elementsOptions"
                #default="{ elements }"
                ref="elms"
              >
                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="card_number"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Card Number
                  </label>

                  <div
                    class="flex items-center border-gray-500 border rounded-md placeholder-gray-400"
                  >
                    <span class="brand"
                      ><i
                        :class="
                          'fa ' +
                          ccBrand +
                          ' text-4xl mr-4 text-gray-400 pt-1 ml-2'
                        "
                        id="brand-icon"
                      ></i
                    ></span>

                    <StripeElement
                      type="cardNumber"
                      :elements="elements"
                      class="block w-full px-3 py-2"
                      @change="changeBrand($event)"
                      ref="cardNumber"
                    />
                  </div>
                </div>

                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="card_expiry"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Card Expiry
                  </label>

                  <div
                    class="w-1/2 flex items-center border-gray-500 border rounded-md placeholder-gray-400"
                  >
                    <span class=""
                      ><i
                        :class="'fa fa-calendar text-4xl mr-4 text-gray-400 pt-1 ml-2'"
                        id=""
                      ></i
                    ></span>

                    <StripeElement
                      type="cardExpiry"
                      :elements="elements"
                      class="block w-full px-4 py-2"
                      ref="cardExpiry"
                    />
                  </div>
                </div>

                <div class="mt-3 sm:mx-auto sm:w-full">
                  <label
                    for="card_expiry"
                    class="block text-sm font-medium text-gray-700"
                  >
                    CVC
                  </label>
                  <div
                    class="w-1/2 flex items-center border-gray-500 border rounded-md placeholder-gray-400"
                  >
                    <span class=""
                      ><i
                        :class="'far fa-credit-card text-4xl mr-4 text-gray-400 pt-1 ml-2'"
                        id=""
                      ></i
                    ></span>

                    <StripeElement
                      type="cardCvc"
                      :elements="elements"
                      class="block w-full px-4 py-2"
                      ref="cardCvc"
                    />
                  </div>
                </div>
              </StripeElements>

              <p class="text-center font-thin mt-3 text-xs">
                <i class="fas fa-info-circle mr-2 text-blue-800"></i>By clicking
                'complete my donation', you agree to our
                <a
                  class="text-blue-500 underline"
                  href="https://www.aberlour.org.uk/privacy-policy/#:~:text=Aberlour%20holds%20basic%20personal%20information,our%20support%20meets%20your%20needs."
                  target="_new"
                  >privacy policy</a
                >
              </p>

              <button
                @click="pay"
                :disabled="payButtonDisabled"
                :class="
                  payButtonDisabled
                    ? 'cursor-not-allowed bg-gray-400 hover:bg-gray-400'
                    : ' bg-aberlour-green text-white font-semibold cursor-pointer hover:bg-green-700'
                "
                class="mt-4 rounded-md shadow-md py-3 text-xl text-center w-full"
              >
                <i
                  aria-hidden="true"
                  :class="
                    payButtonDisabled
                      ? 'fas fa-circle-notch fa-spin mr-2'
                      : 'fas fa-lock-alt mr-2'
                  "
                ></i>
                Donate £{{ donationAmount }}
              </button>
              <div class="w-full">
                <div
                  class="text-gray-500 items-center flex mt-4 justify-center"
                >
                  <p>Payment powered by</p>
                  <i class="fab fa-cc-stripe text-2xl ml-1"></i>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div
        v-if="
          currentlyActiveStage.number == 1 && donationType == 'Single Donation'
        "
        class="flex text-4xl justify-between text-gray-600 mx-16 mt-4"
      >
        <i class="fab fa-cc-visa"></i>
        <i class="fab fa-cc-mastercard"></i>
        <i class="fab fa-cc-paypal"></i>
        <i class="fab fa-cc-apple-pay"></i>
        <i class="fab fa-google-pay"></i>
      </div>
      <div
        v-else-if="
          currentlyActiveStage.number == 1 && donationType == 'Monthly Donation'
        "
        class="flex text-1xl justify-center text-gray-600 mx-16 mt-4"
      >
        <img src="/img/other/logos/direct-debit-logo.png" width="90px" />
        <div class="bg-black text-white p-2 rounded-md ml-4">
          <i class="fas fa-lock"></i>
        </div>

      </div>

      <div v-else class="mt-4 text-gray-700 text-center">
        Need Help? Call us on
        <a href="tel:01412609190" class="text-blue-500 no-underline"
          >0141 260 9190</a
        >
      </div>

       <div class="mt-5 text-gray-400 text-justify md:hidden" v-if="donationType == 'Monthly Donation'">Your monthly donation will go where the need is greater, to help children now and in future</div>

    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  between,
  email,
} from "vuelidate/lib/validators";

import PaymentRequestButton from "./renderless/Payment-request-button.js";
import PaypalButton from "./renderless/Paypal-button.js";

import smoothReflow from "vue-smooth-reflow";

import DonationSuggestion from "./Donation-suggestion.vue";
import DonationSuggestionBanner from "./Donation-suggestion-banner.vue";

import { StripeElements, StripeElement } from "vue-stripe-elements-plus";



export default {
  mixins: [smoothReflow],

  props: ["embed", "campaign", "otherways"],

  data() {
    const stripeInstance = Stripe(process.env.MIX_STRIPE_KEY);

    return {
      gender: '',
      expressCheckoutAvailable: false,
      payButtonDisabled: false,
      complete: false,
      stripe: stripeInstance,
      stripeKey: process.env.MIX_STRIPE_KEY,
      currentAppUrl: process.env.MIX_URL,
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      elementsOptions: {
        // style: {
        //   base: {
        //     iconColor: "#c4f0ff",
        //     color: "#fff",
        //     fontWeight: "500",
        //     fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
        //     fontSize: "18px",
        //     fontSmoothing: "antialiased",
        //     ":-webkit-autofill": {
        //       color: "#fce883",
        //     },
        //     "::placeholder": {
        //       color: "#87BBFD",
        //     },
        //   },
        //   invalid: {
        //     iconColor: "#FFC7EE",
        //     color: "#FFC7EE",
        //   },
        // },
      },
      cardOptions: {
        style: {
          base: {
            iconColor: "#4C1D95",
            color: "#374151",
            fontWeight: "600",
            fontFamily: "Nunito, sans-serif",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            ":-webkit-autofill": {
              color: "#374151",
            },
            "::placeholder": {
              color: "#374151",
            },
          },
          invalid: {
            iconColor: "#EF4444",
            color: "#EF4444",
          },
        },
        hidePostalCode: true,
      },
      card: null,
      paymentRequestOptions: {
        country: "GB",
        currency: "gbp",
        total: {
          label: "Donation to Aberlour",
          amount: 1000,
        },
        requestPayerName: true,
        requestPayerEmail: true,
      },
      donationAmount: 10,
      errorMessage: null,
      singleDonationSuggestions: [
        {
          amount: 10,
          image: "/img/brand/donation-suggestions/1.jpg",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          position: 1,
        },
        {
          amount: 25,
          image: "/img/brand/donation-suggestions/2.jpg",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          position: 2,
        },
        {
          amount: 50,
          image: "/img/brand/donation-suggestions/3.jpg",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          position: 3,
        },
        {
          amount: "Other",
          image: "/img/brand/donation-suggestions/4.jpg",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          position: 4,
        },
      ],
      monthlyDonationSuggestions: [
        {
          amount: 3,
          image: "/img/brand/donation-suggestions/4.jpg",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          position: 1,
        },
        {
          amount: 5,
          image: "/img/brand/donation-suggestions/3.jpg",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          position: 2,
        },
        {
          amount: 10,
          image: "/img/brand/donation-suggestions/1.jpg",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          position: 3,
        },
        {
          amount: "Other",
          image: "/img/brand/donation-suggestions/2.jpg",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          position: 4,
        },
      ],
      suggestionAmount: 10,
      suggestionImage: "/img/brand/donation-suggestions/1.jpg",
      suggestionText:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      suggestionPosition: 1,
      donationType: "Single Donation",
      donationSuggestions: null,
      title: null,
      firstName: null,
      lastName: null,
      nameOnCard: null,
      email: null,
      phone: null,
      giftAid: false,
      addressSearch: null,
      addressLookupOptions: [],
      addressNumber: null,
      addressLine1: null,
      addressLine2: null,
      addressTown: null,
      addressRegion: null,
      addressPostCode: null,
      marketingPrefEmail: false,
      marketingPrefPhone: false,
      marketingPrefText: false,
      marketingPrefPost: false,
      marketingSourceCode: null,
      disableSubmit: false,
      giftAidReadMore: false,
      paymentMethod: null,
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      ccBrand: "fa-credit-card",
      ddPaymentDate: 1,
      ddAccountHolderName: null,
      ddAccountNumber: null,
      ddSortCode: null,
      preferredPaymentDays: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      express: null,
      hideSuggestions: 'block',
      leftCircleText: null,
      rightCircleText: null,
      secureCardIframeSource: null
    };
  },

  validations: {
    title: {
      required,
    },
    firstName: {
      required,
      minLength: minLength(3),
    },
    lastName: {
      required,
    },
    email: {
      required,
      email,
    },
    phone: {
      maxLength: maxLength(15),
      minLength: minLength(11),
    },
    addressLine1: {
      required,
    },
    addressTown: {
      required,
    },
    addressRegion: {
      required,
    },
    addressPostCode: {
      required,
    },
    donorValidationGroup: ["title", "firstName", "lastName", "email", "phone"],
    addressValidationGroup: ["addressLine1", "addressTown", "addressPostCode"],
  },

  computed: {
    singleDonationGiftAidAmount() {
      var value = this.donationAmount * 1.25;
      return value.toFixed(2);
    },
    currentlyActiveStage() {
      let activeStage = this.$store.getters.currentlyActiveStage;

      if (
        activeStage.number == 5 &&
        this.paymentMethod == "credit-debit-card"
      ) {
        //  setTimeout(()=>{
        //     this.card = this.stripe.elements().create('card', this.cardOptions );
        //     this.card.mount('#card-element')
        // },1000);
        //                          setTimeout(()=>{
        // var elements = this.stripe.elements();
        // var style = {
        //   base: {
        //     iconColor: '#666EE8',
        //     color: '#31325F',
        //     lineHeight: '40px',
        //     fontWeight: 300,
        //     fontFamily: 'Helvetica Neue',
        //     fontSize: '15px',
        //     '::placeholder': {
        //       color: '#CFD7E0',
        //     },
        //   },
        // };
        //         var cardNumberElement = elements.create('cardNumber', {
        //   style: style
        // });
        // cardNumberElement.mount('#card-number-element');
        // var cardExpiryElement = elements.create('cardExpiry', {
        //   style: style
        // });
        // cardExpiryElement.mount('#card-expiry-element');
        // var cardCvcElement = elements.create('cardCvc', {
        //   style: style
        // });
        // cardCvcElement.mount('#card-cvc-element');
        //             },250);
      }

      return activeStage;
    },
    nextStage() {

    

      return this.$store.getters.nextStage;
    },
    donationInfo() {
      var di = {};

      di.donationAmount = this.donationAmount;
      di.giftAid = this.giftAid;
      di.title = this.title;
      di.firstName = this.firstName;
      di.lastName = this.lastName;
      di.email = this.email;
      di.phone = this.phone;
      di.addressNumber = this.addressNumber;
      di.addressLine1 = this.addressLine1;
      di.addressLine2 = this.addressLine2;
      di.addressTown = this.addressTown;
      di.addressRegion = this.addressRegion;
      di.addressPostCode = this.addressPostCode;
      di.marketingPrefEmail = this.marketingPrefEmail;
      di.marketingPrefPhone = this.marketingPrefPhone;
      di.marketingPrefText = this.marketingPrefText;
      di.marketingPrefPost = this.marketingPrefPost;
      di.marketingSourceCode = this.marketingSourceCode;
      di.campaign = this.campaign;
      di.giftAid = this.giftAid;

      return di;
    },
  },

  components: {
    PaymentRequestButton,
    PaypalButton,
    DonationSuggestion,
    DonationSuggestionBanner,
    StripeElements,
    StripeElement,
  },
  beforeMount(){

          //NB to use .env variables in vue, they need to be prefixed with MIX_ and you need to clear config cache AND restart
          //asset compilation for them to pull through.

          this.stripeKey = process.env.MIX_STRIPE_KEY;
          this.currentAppUrl = process.env.MIX_URL;
  },

  mounted() {
    // this.card = this.stripe.elements().create('card', this.cardOptions );
    // this.card.mount('#card-element')

    //get URL Parameters for marketing source
    var isInIframe = (parent !== window);
    var uri = decodeURI(document.location.href);


    if (isInIframe) {

      window.parent.postMessage('hello', '*');
      window.addEventListener("message", this.receiveMessage, false);

    }else{

        var uriSplit = decodeURI(window.location.href).split('?');
        if(uriSplit[1]){
        var sourceCodeSplit = uriSplit[1].split("=");
        var sourceCode = sourceCodeSplit[1].replace(/["]+/g, '');
        this.marketingSourceCode = sourceCode;
    }
}



    //set circle text based on campaign
    if(this.campaign == 2 || !this.campaign){

      this.leftCircleText = "Stop children going to bed with empty tummies";
      this.rightCircleText = "Aberlour is here to help for the long term";

    }else if(this.campaign == 6){

      this.leftCircleText = "Children need your help right now";
      this.rightCircleText = "Your donation will provide much needed relief";


    }else{

      this.leftCircleText = "Every child deserves the chance to thrive";
      this.rightCircleText = "Your donation will give children a brighter future";

    }

    //listen for donation suggestion changes
    this.$root.$on("unselect-donation-suggestions", (data) => {
      if(data){
      this.donationAmount = data.suggestedAmount;
      this.suggestionAmount = data.suggestedAmount;
      this.suggestionImage = data.image;
      this.suggestionText = data.text;
      this.suggestionPosition = data.position;
      }
    });


    this.$root.$on("clear-payment-request", (data) => {
      //if back button is pressed
      this.paymentMethod = null;
    });

    this.donationSuggestions = this.singleDonationSuggestions;

    this.$root.$on("unselect-donation-type-selection", (data) => {
      this.hideSuggestions = "opacity-0";
      this.donationType = data.selected;

    //without this the transition on the donation suggestions is wonky
    this.$root.$emit('unselect-donation-suggestions');

      //reset the banner bubble pointer
      var min = null;

      if (this.donationType == "Single Donation") {
        min = this.singleDonationSuggestions.reduce(
          (min, p) => (p.amount < min ? p.amount : min),
          this.singleDonationSuggestions[0].amount
        );
      } else {
        min = this.monthlyDonationSuggestions.reduce(
          (min, p) => (p.amount < min ? p.amount : min),
          this.monthlyDonationSuggestions[0].amount
        );
      }

      this.donationAmount = min;
      this.suggestionAmount = min;
      this.suggestionPosition = 1;

       this.$root.$emit("manual-donation-amount-entered", {amount:min})

      setTimeout(() => {

        if (this.donationType == "Single Donation") {
          this.donationSuggestions = this.singleDonationSuggestions;
        } else {
          this.donationSuggestions = this.monthlyDonationSuggestions;
        }
            this.hideSuggestions = "opacity-100";
      }, 400);


    });

    //enables express checkout if payment metyhod is available
    this.$root.$on("canMakePayment", (event) => {
      this.expressCheckoutAvailable = true;
    });

    //controls scrolling when elements change size
    this.$smoothReflow();
  },
  watch: {
    donationAmount: function (newAmount, oldAmount) {
      var val = newAmount;

      val = Number(val);

      this.paymentRequestOptions.total.amount = val.toFixed(2) * 100;
    },
    donationType: function (newType, oldType) {
      if (newType == "Single Donation") {
        this.rightCircleText = "Your donation will give children a brighter future"     
       } else {
        this.rightCircleText = 'Your monthly donation will go where the need is greater to help children now and in future'

      }
    },
  },
  methods: {
    //recaptcha used for monthly subscriptions
     async recaptcha() {
        this.payButtonDisabled = true;

        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded();

        // Execute reCAPTCHA with action "login".
        const token = await this.$recaptcha('CHECKOUT');

        //verify token
        axios.post('/verify-captcha', {token: token}).then((res)=>{
          this.setUpMonthly();

        }).catch((error) => {
          alert('Failed Captcha Check! Please contact support.');
          this.payButtonDisabled = false;
      });
     },
    //sets up payment  
    pay() {

      
      if(this.gender != ''){
        alert('error - please email help@auriga.technology for more information')
      }

      this.payButtonDisabled = true; //disables button
      this.$v.$reset(); //redo validation
      //check validation
      if (
        this.$v.donorValidationGroup.$invalid ||
        this.$v.addressValidationGroup.$invalid
      ) {
        this.$v.$touch();
        this.$swal({
          title: "More Information Required!",
          icon: "info",
          text: "Please ensure you have filled in your address and personal details...",
          showCancelButton: false,
          showConfirmButton: true,
        });
        this.payButtonDisabled = false;

        return;
      }
      
      //clear all error messages
      this.errorMessage = null;
      //need to put this into a variable so we can access it in stripe
      let c = this;

      //get stripe elements from ref in template
      const groupComponent = this.$refs.elms;
      const cardComponent = this.$refs.cardNumber;

      //Get stripe card element
      const cardElement = cardComponent.stripeElement;

      // Access instance methods, e.g. createToken()
      groupComponent.instance.createToken(cardElement).then((result) => {
        // Handle result.error or result.token
      });

      //create the payment method
      groupComponent.instance
        .createPaymentMethod({
          type: "card",
          card: cardElement,
          billing_details: {
            name: this.firstName + this.lastName,
            email: this.email,
          },
        })
        .then((res) => {
          //check for any errors and display them
          if (res.error) {
            c.errorMessage = res.error.message;
            c.complete = false;
            c.payButtonDisabled = false;
          } else {

            //send the payment method to the backend (along with all the other form data)
            c.sendPaymentMethod(res.paymentMethod);

            //processing message
            this.$swal({
              text: "Donation Processing - Please wait",
              buttons: false,
            });
            this.complete = true;
          }
        });
    },
    expressPay(event) {

    //Express payment Handler
      axios
        .post("/donations-handler/express-donation", {
          token: event,
          donationAmount: this.donationAmount,
        })
        .then((res) => {
          this.stripe
            .confirmCardPayment(
              res.data.intent.client_secret,
              { payment_method: event.paymentMethod.id },
              { handleActions: false }
            )
            .then((confirmResult) => {


              if (confirmResult.error) {
                // Report to the browser that the payment failed, prompting it to
                // re-show the payment interface, or show an error message and close
                // the payment interface.
                event.complete("fail");

                this.$swal({
                  title: "Error! We could not process your payment.",
                  icon: "error",
                  text: confirmResult.error,
                  buttons: false,
                  timer: 5000,
                });
              } else {
                // Report to the browser that the confirmation was successful, prompting
                // it to close the browser payment method collection interface.
                event.complete("success");
                this.$swal({
                  title: "Payment Successful",
                  icon: "success",
                  text: "Thank you!",
                  buttons: false,
                  timer: 4000,
                });

                //save details
                // console.log(event.payerName);
    
                this.firstName = event.payerName;
                this.lastname = event.payerName;
                this.email = event.payerEmail;
                this.phone = event.payerPhone;
                this.addressLine1 = event.paymentMethod.billing_details.address.line1;
                this.addressLine2 = event.paymentMethod.billing_details.address.line2;
                this.addressTown = event.paymentMethod.billing_details.address.city;
                this.addressPostCode = event.paymentMethod.billing_details.address.postal_code;
                //paymentHandler
                axios
                  .post("/donations-handler/save-express-donation", {
                    amount: this.donationAmount,
                    giftAid: this.giftAid,
                    title: this.title,
                    first_name: this.firstName,
                    last_name: this.lastName,
                    email: this.email,
                    phone: this.phone,
                    address_house_number: this.addressNumber,
                    address_line_1: this.addressLine1,
                    address_line_2: this.addressLine2,
                    address_town: this.addressTown,
                    address_region: this.addressRegion,
                    address_postcode: this.addressPostCode,
                    marketing_pref_email: this.marketingPrefEmail,
                    marketing_pref_phone: this.marketingPrefPhone,
                    marketing_pref_text: this.marketingPrefText,
                    marketing_pref_post: this.marketingPrefPost,
                    marketing_source_code: this.marketingSourceCode,
                    campaign: this.campaign,
                    uk_taxpayer: this.giftAid,
                    confirm: confirmResult,
                  })
                  .then((res) => {

                      var donationId =  res.data.donation_id;

                      //  ga('ecommerce:addTransaction', {
                      //   'id': donationId,                               // Transaction ID. Required.
                      //   'affiliation': 'Aberlour Donation Platform',    // Affiliation or store name.
                      //   'revenue': this.donationAmount,                 // Grand Total.
                      //   'shipping': '0',                                // Shipping.
                      //   'tax': '0'                                      // Tax.
                      //   });

                        // ga('ecommerce:addItem', {
                        //     'id': donationId,                               // Transaction ID. Required.
                        //     'name': 'General Single Donation (Express)',              // Product name. Required.
                        //     'sku': '1',                                     // SKU/code.
                        //     'category': 'Donation',                         // Category or variation.
                        //     'price': this.donationAmount,                   // Unit price.
                        //     'quantity': '1'                                 // Quantity.
                        // });

                        // ga('ecommerce:send');

                        // ga('ecommerce:clear');

         
          //   gtag('event', 'purchase', {
          //         'allow_custom_scripts': true,
          //         'value': this.donationAmount,
          //         'transaction_id': donationId,
          //         'send_to': 'DC-11763200/donat0/donat0+transactions'
          //         });


          //  fbq('track', 'Donate',
          //   {
          //       value: this.donationAmount,
          //       currency: 'GBP',
          //       contents: [
          //       {
          //           id: donationId,
          //           quantity: 1
          //       },
          //       ],
          //       content_type: 'express_donation'
          //   }
          //   );


                        window.parent.location.href =
                        "/thank-you/" +
                        res.data.donation_id +
                        "/" +
                        res.data.donor_id+
                        "/" +
                        res.data.campaign;
                  });

                // console.log(event);
                // console.log(confirmResult);

                // Check if the PaymentIntent requires any actions and if so let Stripe.js
                // handle the flow. If using an API version older than "2019-02-11" instead
                // instead check for: `paymentIntent.status === "requires_source_action"`.
                if (confirmResult.paymentIntent.status === "requires_action") {
                  // Let Stripe.js handle the rest of the payment flow.
                  this.stripe.confirmCardPayment(clientSecret)
                  .then(function (result) {
                      if (result.error) {
                        // The payment failed -- ask your customer for a new payment method.
                      } else {
                        // The payment has succeeded.
                      }
                    });
                } else {
                  // The payment has succeeded.
                }
              }
            });
        });
    },
    sendPaymentMethod(paymentMethod) {

        let authToken = null;

          axios.post('/donations/get-auth-token').then((res) => {
            authToken = res.data;
        


      //send donation details to the server along with the form details
      axios
        .post("/donations/one-off", {
          payment_method: paymentMethod,
          amount: this.donationAmount,
          giftAid: this.giftAid,
          title: this.title,
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          phone: this.phone,
          address_house_number: this.addressNumber,
          address_line_1: this.addressLine1,
          address_line_2: this.addressLine2,
          address_town: this.addressTown,
          address_region: this.addressRegion,
          address_postcode: this.addressPostCode,
          marketing_pref_email: this.marketingPrefEmail,
          marketing_pref_phone: this.marketingPrefPhone,
          marketing_pref_text: this.marketingPrefText,
          marketing_pref_post: this.marketingPrefPost,
          marketing_source_code: "_ma",
          campaign:this.campaign,
          uk_taxpayer: this.giftAid,
          token: authToken
        })
        .then((res) => {
          // alert();
          this.$swal.close();
          // console.log('******* return from saving donation ******')
          // console.log(res.data);

          var donationId = res.data.donation_id;

          //log marekting events on google analytics
          // ga('ecommerce:addTransaction', {
          //   'id': donationId,                               // Transaction ID. Required.
          //   'affiliation': 'Aberlour Donation Platform',    // Affiliation or store name.
          //   'revenue': this.donationAmount,                 // Grand Total.
          //   'shipping': '0',                                // Shipping.
          //   'tax': '0'                                      // Tax.
          //   });

          // ga('ecommerce:addItem', {
          //   'id': donationId,                               // Transaction ID. Required.
          //   'name': 'General Single Donation',              // Product name. Required.
          //   'sku': '1',                                     // SKU/code.
          //   'category': 'Donation',                         // Category or variation.
          //   'price': this.donationAmount,                   // Unit price.
          //   'quantity': '1'                                 // Quantity.
          // });

          // ga('ecommerce:send');

          // ga('ecommerce:clear');

          // gtag('event', 'purchase', {
          // 'allow_custom_scripts': true,
          // 'value': this.donationAmount,
          // 'transaction_id': donationId,
          // 'send_to': 'DC-11763200/donat0/donat0+transactions'
          // });

          //log analytics on Facebook
            // fbq('track', 'Donate',
            // {
            //     value: this.donationAmount,
            //     currency: 'GBP',
            //     contents: [
            //     {
            //         id: donationId,
            //         quantity: 1
            //     },
            //     ],
            //     content_type: 'single_donation'
            // }
           // );

            //redirect to feedback page
              window.parent.location.href =
            "/thank-you/" + res.data.donation_id + "/" + res.data.donor_id+ "/" + res.data.campaign;
        })
        .catch((error) => {

            // console.log("***********************")
            // console.log(error.response);

            if(error.response.status == 422){

              this.$swal.close();

               //prompt donor
                    this.$swal({
                      title: "Error processing payment",
                      icon: "error",
                      text: error.response.data.message,
                      buttons: false,
                      timer: 5000
                    });

              this.payButtonDisabled = false; //disables button
              this.errorMessage = error.response.data.message;
            }else{

            

            //grab stripe components
            const groupComponent = this.$refs.elms;
            const cardComponent = this.$refs.cardNumber;
            const expiryComponent = this.$refs.cardExpiry;
            const cvcComponent = this.$refs.cardCvc;

            // Get stripe card element
            const cardElement = cardComponent.stripeElement;
            const expiryElement = expiryComponent.stripeElement;
            const cvcElement = cvcComponent.stripeElement;
            

            this.$swal.close();
            // window.parent.location.href = error.response.data.url;

          

            //use stripe method to confirm card payment has been completed
            //if not it is probably because of the 3DS2 authenticatiuon requirement
            groupComponent.instance.confirmCardPayment(
              error.response.data.exception.payment.client_secret,  //coming from the exception in the backend
            {
              payment_method: {card: cardElement},
              return_url: this.currentAppUrl+'/1/secured-transaction-return',
            },
            // Disable the default next action handling.
            {handleActions: false}
        
          ).then((result) => {


            // console.log(result.paymentIntent);
            // console.log(result.paymentIntent.next_action.redirect_to_url.url);

            // alert(result.paymentIntent.next_action.redirect_to_url.url);

            //processing message to confirm authentication
            this.$swal({
              title: "We need to authenticate your card",
              text: "Contacting your bank, please wait...",
              buttons: false,
              timer: 3000
            });

            //show modal for the 3DS authentication and populate iframe with the authentication URL from the payment intent recieved from the exception
            this.$modal.show('card-authenticate-modal', {iframeSrc: result.paymentIntent.next_action.redirect_to_url.url })

            //listen for message from the i-frame which redirects to /handle-secured-transaction which is a view that sends the parent the message
            window.addEventListener('message', (ev) => {
             if (ev.data === '3DS-authentication-complete') {
              this.$modal.hide('card-authenticate-modal');

              // Check the PaymentIntent again to ensure it has been correctly authenticated
              this.stripe.retrievePaymentIntent(error.response.data.exception.payment.client_secret)
              .then((result) =>  {
                if (result.error) {
                  // PaymentIntent client secret was invalid (should never happen!)
                  alert('Invalid stripe secret, please contact support');
                } else {

                  if (result.paymentIntent.status === 'succeeded') {
                    //payment has succeeded

                    //prompt donor
                    this.$swal({
                      title: "Thank you!",
                      icon: "success",
                      text: "We have confirmed your card with your bank, please wait while we process...",
                      buttons: false,
                      timer: 5000
                    });

                  //send payment method to the server to log the donation. We are sending ('paid_by_secure') as the payment intent so that 
                  //the server doesn't try and charge again as this payment has been charged on the front end using 3DS
                  this.sendPaymentMethod('paid_by_secure');


                  } else if (result.paymentIntent.status === 'requires_payment_method') {
                    // Authentication failed, prompt the donor to enter another payment method
                    // console.log('******************');
                    // console.log(result.paymentIntent);

                     

                  this.errorMessage = result.paymentIntent.last_payment_error.message;

                  cardElement.clear();
                  expiryElement.clear();
                  cvcElement.clear();

                   this.$swal({
                        title: "Sorry about this!",
                        icon: "error",
                        text: '3DS authentication failed. This can happen because of incorrect card details, or because you need to complete an additional verification step with your bank. Please try again or contact our team at hello@aberlour.org.uk for assistance.',
                        buttons: false,
                        timer: 8000,
                      });


                let formData= {
                  first_name: this.firstName,
                  last_name: this.lastName,
                  email: this.email,
                  phone: this.phone,
                  address_house_number: this.addressNumber,
                  address_line_1: this.addressLine1,
                  address_line_2: this.addressLine2,
                  address_town: this.addressTown,
                  address_region: this.addressRegion,
                  address_postcode: this.addressPostCode,
                  marketing_pref_email: this.marketingPrefEmail,
                  marketing_pref_phone: this.marketingPrefPhone,
                  marketing_pref_text: this.marketingPrefText,
                  marketing_pref_post: this.marketingPrefPost,
                  marketing_source_code: this.marketingSourceCode,
                }

                  axios.post('/donations/failed-3ds-payment', {paymentIntent: result.paymentIntent, formData: formData}).then((res)=>{

                  }).catch((error) => {
                    
                  });

                  this.payButtonDisabled = false;

                  setTimeout(()=>{ 
                    
                    this.errorMessage = "";

                  }, 5000);
                  }
             }});
    }
  }, false);
});

            }

          // if (error.response) {
          //   this.errorMessage = error.response.data.message;
          // } else {
          //   this.errorMessage = error;
          // }
        });

          }).catch((error) => {
            alert('Cant get token - contact support!');
            this.payButtonDisabled = false;
          });
    },
    deselectSuggestions() {
      this.$root.$emit("unselect-donation-suggestions", {
        suggestedAmount: this.donationAmount,
      });
      this.$root.$emit("manual-donation-amount-entered", {
        amount: this.donationAmount,
      });
    },
    redirect() {},
    stageManager(nextStage) {
      if (this.donationAmount == "Other") {
        this.$swal({
          title: "No Donation amount entered",
          icon: "info",
          text: "Please enter an amount to donate or click a donation amount.",
          showCancelButton: false,
          showConfirmButton: true,
          timer: 3000,
        });

        return false;
      }

      this.$v.$reset();

      if (
        this.$v.donorValidationGroup.$invalid &&
        this.currentlyActiveStage.number == 2
      ) {
        this.$v.$touch();
      } else if (
        this.$v.addressValidationGroup.$invalid &&
        this.currentlyActiveStage.number == 3
      ) {
        this.$v.$touch();
      } else {
        // console.log(nextStage);


        this.$store.dispatch("goToNextStage", nextStage);
        document.body.scrollTop = document.documentElement.scrollTop = 30;
        
      }


    },
    searchAddress(search, loading) {
      loading(true);
      if(search.length >= 3){
      this.search(loading, search, this);
      }
      loading(false);
    },
    search: _.debounce((loading, search, vm) => {
      axios
        .post("https://api.craftyclicks.co.uk/address/1.1/find", {
          key: "e2307-9e79f-dc811-0670f",
          query: search,
          country: "gb",
        })
        .then((res) => {
          vm.setAddressLookupOptions(res.data);
        });
    }, 200),
    setAddressLookupOptions(data) {


      var res = data.results;

      this.addressLookupOptions = [];

      res.forEach((add) => {
        var option = add.labels[1] + ", " + add.labels[0];
        this.addressLookupOptions.push({
          addressString: option,
          fullDataArray: add,
        });
      });
    },
    selectAddress(selectedValue) {
      if (selectedValue.fullDataArray) {
        axios
          .post("https://api.craftyclicks.co.uk/address/1.1/retrieve", {
            key: "e2307-9e79f-dc811-0670f",
            id: selectedValue.fullDataArray.id,
            country: "gb",
          })
          .then((res) => {
            let data = res.data.result;

            this.addressNumber = data.building_number;
            this.addressLine1 = data.line_1;
            this.addressLine2 = data.line_2;
            this.addressTown = data.locality;
            this.addressRegion = data.province_name;
            this.addressPostCode = data.postal_code;
          });
      }
    },
    toggleSwitch(switchName) {
      //should perhaps use an array instead of this but it works and I do it all the time! -ap
      eval(
        "this.marketingPref" +
          switchName +
          " = !this.marketingPref" +
          switchName
      );
      return true;
    },
    changeBrand(event) {
      let brand = event.brand;

      var cardBrandToPfClass = {
        visa: "fa-cc-visa",
        mastercard: "fa-cc-mastercard",
        amex: "fa-cc-american-express",
        discover: "fa-cc-discover",
        diners: "fa-cc-diners",
        jcb: "fa-cc-jcb",
        unknown: "fa-credit-card",
      };

      var pfClass = "fa-credit-card";
      if (brand in cardBrandToPfClass) {
        this.ccBrand = cardBrandToPfClass[brand];
      } else {
        this.ccBrand = "fa-credit-card";
      }
    },
    expressCheckout() {
      this.express = !this.express;
    },
    setUpMonthly() {
        //payment handler
      axios
        .post("/handle-monthly-donation", {
          amount: this.donationAmount,
          giftAid: this.giftAid,
          title: this.title,
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          phone: this.phone,
          address_house_number: this.addressNumber,
          address_line_1: this.addressLine1,
          address_line_2: this.addressLine2,
          address_town: this.addressTown,
          address_region: this.addressRegion,
          address_postcode: this.addressPostCode,
          marketing_pref_email: this.marketingPrefEmail,
          marketing_pref_phone: this.marketingPrefPhone,
          marketing_pref_text: this.marketingPrefText,
          marketing_pref_post: this.marketingPrefPost,
          marketing_source_code: this.marketingSourceCode,
          campaign: this.campaign,
          uk_taxpayer: this.giftAid,
        })
        .then((res) => {

          var donationId = res.data.session.id;

          // ga('ecommerce:addTransaction', {
          //   'id': donationId,                               // Transaction ID. Required.
          //   'affiliation': 'Aberlour Donation Platform',    // Affiliation or store name.
          //   'revenue': this.donationAmount,                 // Grand Total.
          //   'shipping': '0',                                // Shipping.
          //   'tax': '0'                                      // Tax.
          //   });

          // ga('ecommerce:addItem', {
          //   'id': donationId,                               // Transaction ID. Required.
          //   'name': 'General Monthly Donation',             // Product name. Required.
          //   'sku': '1',                                     // SKU/code.
          //   'category': 'Donation',                         // Category or variation.
          //   'price': this.donationAmount,                   // Unit price.
          //   'quantity': '1'                                 // Quantity.
          // });

          // ga('ecommerce:send');

          // ga('ecommerce:clear');

        // gtag('event', 'purchase', {
        //   'allow_custom_scripts': true,
        //   'value': this.donationAmount,
        //   'transaction_id': donationId,
        //   'send_to': 'DC-11763200/donat0/donat0+transactions'
        //   });


            //   fbq('track', 'Donate',
            // {
            //     value: this.donationAmount,
            //     currency: 'GBP',
            //     contents: [
            //     {
            //         id: donationId,
            //         quantity: 1
            //     },
            //     ],
            //     content_type: 'monthly_donation'
            // }
            // );

          //checkout then returns to /bacs-setup-success which redirects to feedback page

          this.stripe
            .redirectToCheckout({
              sessionId: res.data.session.id,
            })
            .then(function (result) {

                  

              alert(result.error.message + ' Please contact help@auriga.technology');
            });
        }).catch((error) => {
          this.errorMessage = error.response.data.exception;
          this.payButtonDisabled = false;

        });
    },
    fieldStatus(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty,
      };
    },
    vSelectfieldStatus(validation) {
      if (validation.$error) {
        return "error rounded-md";
      } else {
        return "rounded-md select-default";
      }
    },
     receiveMessage(event)  {
    if(event.origin === "http://aberlour-april.test" ||event.origin === "https://www.aberlour.org.uk" || event.origin === "https://aberlour.org.uk"  ){
        var uri = decodeURI(event.data);

        var parameterSplit = uri.split("?");
        if(parameterSplit[1]){
        var sourceCodeSplit = parameterSplit[1].split("=");
        var sourceCode = sourceCodeSplit[1].replace(/["]+/g, '');

        this.marketingSourceCode = sourceCode;
        }

}

}
  },
  facebookTracking(donationId, donationType, donationAmount){

      axios.post('/facebook-tracking',{'donationId': donationId, 'donationType':donationType, 'donationAmount':donationAmount }).then((res) => {
        //console.log('fb-trk')
      });

  }
};
</script>

<style>
 .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to  {
  opacity: 0;
}


.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

/* V-Select Placeholder colour */
.vs__search::placeholder {
  color: rgba(55, 65, 81, 700);
}

.vs__search {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #fff;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0rem;
  padding-right: 0rem;
  padding-bottom: 0rem;
  padding-left: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  color: rgba(55, 65, 81, 700);
}

.vs--single:focus {
  outline: 1px dashed red;
}

.vs__no-options {
  padding-top: 0.5rem;
  color: gray;
}

/* validation styles */

.dirty {
  border-color: #5a5;
}

/* .dirty:focus {
  outline-color: #8E8;
} */

.error {
  border-color: red;
}

.select-default {
  border: none;
}

.gender-field{
  display: none;
}

/* .error:focus {
  outline-color: #F99;
} */
</style>
